import { isLanguageCode } from "@next-platform/packages-ts-types";
export default function normalizeLanguageCodes(codes) {
    if (!codes?.length) {
        return [];
    }
    const normalizedCodes = new Set();
    for (const code of codes) {
        if (typeof code !== "string") {
            continue;
        }
        const normalizedCode = code.trim().toLowerCase();
        if (isLanguageCode(normalizedCode)) {
            normalizedCodes.add(normalizedCode);
        }
    }
    return [...normalizedCodes];
}
